/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkContactPrefillDto } from '../models/work-contact-prefill-dto';
import { WorkEventDetailsDto } from '../models/work-event-details-dto';
import { WorkSuccessDto } from '../models/work-success-dto';

@Injectable({ providedIn: 'root' })
export class WorkWebsiteFormsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `websiteFormsV2ControllerGetContactPrefill()` */
  static readonly WebsiteFormsV2ControllerGetContactPrefillPath = '/v2/website/forms/contact-prefill';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `websiteFormsV2ControllerGetContactPrefill()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteFormsV2ControllerGetContactPrefill$Response(
    params: {
      contact: string;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContactPrefillDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWebsiteFormsV2Service.WebsiteFormsV2ControllerGetContactPrefillPath, 'get');
    if (params) {
      rb.query('contact', params.contact, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContactPrefillDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `websiteFormsV2ControllerGetContactPrefill$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteFormsV2ControllerGetContactPrefill(
    params: {
      contact: string;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<WorkContactPrefillDto> {
    return this.websiteFormsV2ControllerGetContactPrefill$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContactPrefillDto>): WorkContactPrefillDto => r.body)
    );
  }

  /** Path part for operation `websiteFormsV2ControllerGetEventDetails()` */
  static readonly WebsiteFormsV2ControllerGetEventDetailsPath = '/v2/website/forms/event-details';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `websiteFormsV2ControllerGetEventDetails()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteFormsV2ControllerGetEventDetails$Response(
    params: {
      eventId: string;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkEventDetailsDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWebsiteFormsV2Service.WebsiteFormsV2ControllerGetEventDetailsPath, 'get');
    if (params) {
      rb.query('eventId', params.eventId, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkEventDetailsDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `websiteFormsV2ControllerGetEventDetails$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  websiteFormsV2ControllerGetEventDetails(
    params: {
      eventId: string;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<WorkEventDetailsDto> {
    return this.websiteFormsV2ControllerGetEventDetails$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkEventDetailsDto>): WorkEventDetailsDto => r.body)
    );
  }

  /** Path part for operation `websiteFormsV2ControllerSendForm()` */
  static readonly WebsiteFormsV2ControllerSendFormPath = '/v2/website/forms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `websiteFormsV2ControllerSendForm()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  websiteFormsV2ControllerSendForm$Response(
    params: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: {

/**
 * Name des Formulars
 */
'formName': string;

/**
 * JSON-String mit Formulardaten
 */
'data': string;

/**
 * Dateien (PDF, Word)
 */
'files'?: Array<Blob>;
}
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkWebsiteFormsV2Service.WebsiteFormsV2ControllerSendFormPath, 'post');
    if (params) {
      rb.header('x-api-key', params['x-api-key'], {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `websiteFormsV2ControllerSendForm$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  websiteFormsV2ControllerSendForm(
    params: {

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
      body: {

/**
 * Name des Formulars
 */
'formName': string;

/**
 * JSON-String mit Formulardaten
 */
'data': string;

/**
 * Dateien (PDF, Word)
 */
'files'?: Array<Blob>;
}
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.websiteFormsV2ControllerSendForm$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

}
